import AppRoute from './AppRoute';
import 'react-notifications/lib/notifications.css';
import './App.css';
import { NotificationContainer } from "react-notifications";





const App = () =>  {
 
    return (
      <>
         <AppRoute />
         <NotificationContainer />
      </>
     
    
    );
  
}

export default App;